import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Utils from "../../Utils";
import Button from "../../lib/Button";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class LeaveConfirmationPopup extends Popup
{
    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter();        

        this._disabledBg.visible = false;

        let disabledBg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.tut_bg.texture );
        disabledBg.interactive = true;
        disabledBg.anchor.set( 0.5 );
        disabledBg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( disabledBg );

        let base: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.popup_base.texture );
        base.position.set( ServiceLocator.app.width * 0.5 - base.texture.width * 0.5, ServiceLocator.app.height * 0.5 - base.height * 0.5 );
        this._root.addChild( base );

        let messageText: PIXI.Text = new PIXI.Text( "Are you sure you want to leave?", { 
            fontFamily: "asap_regular", 
            fontSize: 38, 
            fill: 0xffffdf,
            wordWrap: true,
            wordWrapWidth: ServiceLocator.app.width * 0.8,
            align: "center" } );
        messageText.anchor.set( 0.5 );
        messageText.position.set( base.texture.width * 0.5, 194 );
        base.addChild( messageText );

        let acceptBtn: Button = new Button( { on: "popup_button_green" } );
        acceptBtn.anchor.set( 0.5 );
        acceptBtn.position.set( base.texture.width * 0.5 - 142, 350 );
        base.addChild( acceptBtn );
        acceptBtn.on( "pointertap", () => { this._onAcceptBtn_Click(); } );
        //
        let text: PIXI.Text = new PIXI.Text( "ACCEPT", { 
            fontFamily: "asap_extrabold", 
            fontSize: 30, 
            fill: 0xffffdf } );
        text.anchor.set( 0.5 );
        acceptBtn.addChild( text );

        let closeBtn: Button = new Button( { on: "popup_button_red" } );
        closeBtn.anchor.set( 0.5 );
        closeBtn.position.set( base.texture.width * 0.5 + 142, 350 );
        base.addChild( closeBtn );
        closeBtn.on( "pointertap", () => { this._onCancelBtn_Click(); } );
        //
        text = new PIXI.Text( "CANCEL", { 
            fontFamily: "asap_extrabold", 
            fontSize: 30, 
            fill: 0xffffdf } );
        text.anchor.set( 0.5 );
        closeBtn.addChild( text );
    }

        private _onAcceptBtn_Click(): void
        {
            this._onClosed.dispatch( this, true );
        }

        private _onCancelBtn_Click(): void
        {
            this._onClosed.dispatch( this, false );
        }

    // #endregion //
}